import { UseQueryResult, useQuery } from "@tanstack/react-query";
import UsersListResponse from "../../models/API/responseModels/usersListResponse.model";
import { useOktaAuth } from "@okta/okta-react";
import axiosInstance from "../../api";
import { useContext } from "react";
import { ApplicationState } from "../../context/ApplicationStateContext";
import useProfile from "./useProfile";

function usePhysiciansOfOrg(): UseQueryResult<UsersListResponse, any> {
 const { authState } = useOktaAuth();
 const { data, isLoading } = useProfile();
 const {
  state: { selectedOrganization },
 } = useContext(ApplicationState);

 const rolesCheck =
  data?.user?.roles?.includes?.("Office Manager") ||
  data?.user?.roles?.includes?.("Collaborative Order Agreement") ||
  data?.user?.roles?.length > 1;

 return useQuery({
  queryKey: ["physiciansList", selectedOrganization],
  queryFn: ({ queryKey }) => {
   const [_key, selectedOrganization]: any = queryKey;
   return axiosInstance
    .get(
     `v1/users/new-flow/list?organizationId=${selectedOrganization}&allPhysicians=1&isApproved=true`,
     {
      headers: {
       Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
      },
      transformResponse: (res) => {
       let response = JSON.parse(res);
       response = {
        ...response,
        data: response.data.filter((user: any) =>
         user.roles.includes("Physician")
        ),
       };
       return response;
      },
     }
    )
    .then((res) => res.data);
  },
  enabled: !!selectedOrganization && !isLoading && !!data && rolesCheck,
 });
}

export default usePhysiciansOfOrg;
